import type { PermissionKey } from "../features/permissions/permissions";

export const hasPermission = (
  permission: PermissionKey | undefined,
  permissions: PermissionKey[],
) => {
  return (
    !permission ||
    permissions.includes(permission) ||
    permissions.includes("admin") ||
    false
  );
};
